import { StringIndexedDictionary } from "../../../../globalTypes";
import { TableColumns } from "../../../../requests/table/types";

// eslint-disable-next-line import/prefer-default-export
export const sortColumns = (
  unsortedCols: TableColumns,
  columnOrderByColumnName: StringIndexedDictionary<number>
): TableColumns => {
  const keys = Object.keys(unsortedCols);

  if (!unsortedCols || keys.length < 1 || columnOrderByColumnName.length < 1) {
    return unsortedCols;
  }

  const sortedKeys = keys.sort(
    (a, b) =>
      (columnOrderByColumnName[a] ?? 0) - (columnOrderByColumnName[b] ?? 0)
  );

  const sortedColumns = {} as TableColumns;

  sortedKeys.forEach((k) => {
    sortedColumns[k] = unsortedCols[k];
  });

  return sortedColumns;
};
